import { useState, useCallback } from "react";
import { useNavigate } from "react-router";
import adminService from "../../services/AdminService";
import TopMenu from "../Dashboard/Menus/TopMenu";
import { Outlet } from "react-router-dom";
import BlueButton from "../common/BlueButton/BlueButton";
import useAsync from "../../services/useAsync";

const Admin = () => {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);

    const checkAdminState = useCallback(async () => {
        let response = await adminService
            .checkAdminState()
            .catch(() => navigate("/dashboard"));

        if (response.status === 200) {
            setIsLoading(false);
        } else {
            navigate("/dashboard");
        }
    }, [navigate]);

    const loadPage = useCallback(async () => {
        setIsLoading(true);

        await Promise.all([checkAdminState()]);

        setIsLoading(false);
    }, [checkAdminState]);

    useAsync(loadPage);

    let displayComponent = <></>;

    if (!isLoading) {
        displayComponent = (
            <>
                <div className="returnButtonContainerAdmin">
                    <BlueButton
                        text="return to user dashboard"
                        isDark={true}
                        onClick={() => navigate("/dashboard")}
                    />
                </div>
                <TopMenu />

                <Outlet />
            </>
        );
    }

    return displayComponent;
};

export default Admin;
